import { useState } from 'react';
import { GOOGLE_API_KEY } from '../../config';

export default function StreetViewThumb({ lat, lng }) {
    const [error, setError] = useState(false);

    if (lat == null || lng == null || !GOOGLE_API_KEY || error) {
        return <div className="host-streetview">Street View preview</div>;
    }

    const url = `https://maps.googleapis.com/maps/api/streetview?size=480x110&location=${lat},${lng}&fov=80&heading=70&pitch=0&key=${GOOGLE_API_KEY}`;

    return (
        <div className="host-streetview">
            <img
                src={url}
                alt="Street View preview"
                onError={() => setError(true)}
            />
        </div>
    );
}
